var React = require('react');

function Create (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Plus symbol representing easily creating an invoice."),React.createElement("description",{"key":1},"Plus symbol representing easily creating an invoice."),React.createElement("path",{"d":"M76 30.65H50.9a2 2 0 01-2-2V3.53a2 2 0 00-2-2H32.68a2 2 0 00-2 2v25.09a2 2 0 01-2 2H3.53a2 2 0 00-2 2v14.22a2 2 0 002 2h25.09a2 2 0 012 2V76a2 2 0 002 2h14.22a2 2 0 002-2V50.9a2 2 0 012-2H76a2 2 0 002-2V32.68a2 2 0 00-2-2.03z","fill":"#fcba14","stroke":"#f27345","strokeMiterlimit":"10","strokeWidth":"3","key":2})]);
}

Create.defaultProps = {"viewBox":"0 0 79.52 79.52","role":"img"};

module.exports = Create;

Create.default = Create;
